// extracted by mini-css-extract-plugin
module.exports = {"OrdersPage":"OrdersPage_OrdersPage__2bH72","Order":"OrdersPage_Order__3SuMs","OrderListHeader":"OrdersPage_OrderListHeader___eFyp","Btns":"OrdersPage_Btns__3CsW4"};